export function handleGetTeamId() {
    return localStorage.getItem('current_team')
}

export function handleErrorMessage(message: any, optionalMessage: string) {
    if (typeof(message) === 'string' && message !== '') return message
    return optionalMessage
}